import { defaultErrorMessages } from './errorMessages';

export enum HttpStatusCode {
  OK = 200,
  BAD_REQUEST = 400,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  UNAUTHORIZED = 401,
  METHOD_NOT_ALLOWED = 405,
  INTERNAL_SERVER = 500,
}

export class AbortError extends Error {
  public readonly title: string;
  public readonly description: string;

  constructor() {
    super(defaultErrorMessages.abortError.description);
    this.title = defaultErrorMessages.abortError.title;
    this.description = defaultErrorMessages.abortError.description;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class BaseError extends Error {
  public readonly name: string;
  public readonly title: string;
  public readonly description: string;

  constructor(
    name: string,
    localizedTitle?: string,
    localizedDescription?: string,
  ) {
    super(localizedDescription || defaultErrorMessages.baseError.description);
    this.name = name;
    this.title = localizedTitle || defaultErrorMessages.baseError.title;
    this.description =
      localizedDescription || defaultErrorMessages.baseError.description;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class BaseHTTPError extends BaseError {
  public readonly httpCode: HttpStatusCode;
  public readonly message: string;

  constructor(
    name: string,
    httpCode: HttpStatusCode,
    message: string,
    localizedTitle?: string,
    localizedDescription?: string,
  ) {
    super(
      name,
      localizedTitle || defaultErrorMessages.fetchError.title,
      localizedDescription || defaultErrorMessages.fetchError.description,
    );
    this.httpCode = httpCode;
    this.message = message;
  }
}

export class BadRequestError extends BaseHTTPError {
  constructor(
    message: string,
    localizedTitle?: string,
    localizedDescription?: string,
  ) {
    super(
      'BAD_REQUEST',
      HttpStatusCode.BAD_REQUEST,
      message,
      localizedTitle || defaultErrorMessages.badRequest.title,
      localizedDescription || defaultErrorMessages.badRequest.description,
    );
  }
}

export class NotFoundError extends BaseHTTPError {
  constructor(
    message: string,
    localizedTitle?: string,
    localizedDescription?: string,
  ) {
    super(
      'NOT_FOUND',
      HttpStatusCode.NOT_FOUND,
      message,
      localizedTitle || defaultErrorMessages.notFound.title,
      localizedDescription || defaultErrorMessages.notFound.description,
    );
  }
}

export class ForbiddenError extends BaseHTTPError {
  constructor(
    message: string,
    localizedTitle?: string,
    localizedDescription?: string,
  ) {
    super(
      'FORBIDDEN',
      HttpStatusCode.NOT_FOUND,
      message,
      localizedTitle || defaultErrorMessages.notFound.title,
      localizedDescription || defaultErrorMessages.notFound.description,
    );
  }
}

export class UnauthorizedError extends BaseHTTPError {
  constructor(
    message: string,
    localizedTitle?: string,
    localizedDescription?: string,
  ) {
    super(
      'UNAUTHORIZED',
      HttpStatusCode.UNAUTHORIZED,
      message,
      localizedTitle || defaultErrorMessages.unauthorized.title,
      localizedDescription || defaultErrorMessages.unauthorized.description,
    );
  }
}
export class InternalServerError extends BaseHTTPError {
  constructor(
    message: string,
    localizedTitle?: string,
    localizedDescription?: string,
  ) {
    super(
      'INTERNAL_SERVER',
      HttpStatusCode.INTERNAL_SERVER,
      message,
      localizedTitle || defaultErrorMessages.internalServerError.title,
      localizedDescription ||
        defaultErrorMessages.internalServerError.description,
    );
  }
}

export class MethodNotAllowedError extends BaseHTTPError {
  constructor(
    message: string,
    localizedTitle?: string,
    localizedDescription?: string,
  ) {
    super(
      'INTERNAL_SERVER',
      HttpStatusCode.METHOD_NOT_ALLOWED,
      message,
      localizedTitle || defaultErrorMessages.internalServerError.title,
      localizedDescription ||
        defaultErrorMessages.internalServerError.description,
    );
  }
}

export class FetchError extends BaseHTTPError {
  constructor(
    statusCode: number,
    message: string,
    localizedTitle?: string,
    localizedDescription?: string,
  ) {
    super(
      'FETCH',
      statusCode,
      message,
      localizedTitle || defaultErrorMessages.fetchError.title,
      localizedDescription || defaultErrorMessages.fetchError.description,
    );
  }
}

export class UnhandledError extends Error {
  public readonly name: string;
  public readonly title: string;
  public readonly description: string;

  constructor(
    name: string,
    localizedTitle?: string,
    localizedDescription?: string,
  ) {
    super(
      localizedDescription || defaultErrorMessages.unhandledError.description,
    );
    this.name = name;
    this.title = localizedTitle || defaultErrorMessages.unhandledError.title;
    this.description =
      localizedDescription || defaultErrorMessages.unhandledError.description;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
